export default "__VITE_ASSET__DpDkvkXT__"